import { CREATE_LEAVE, UPDATE_LEAVE, GET_LEAVES, GET_LEAVE, DELETE_LEAVE } from './types';
import axios from '../../apis/axios';
import history from '../../history';
import { Routes } from '../../routes';
import { formValues } from 'redux-form';

export const createLeave = (formValues) => async (dispatch, getState) => {
	axios
		.post('/leave-request', formValues)
		.then((response) => {
			dispatch({ type: CREATE_LEAVE, payload: response.data });
			history.push(Routes.HumanResources.Leave.Index.path);
		})
		.catch((err) => {});
};
export const getLeaves = () => async (dispatch) => {
	axios
		.get('/leave-request')
		.then((response) => {
			dispatch({ type: GET_LEAVES, payload: response.data });
		})
		.catch((err) => {});
};
export const getLeavesWithFilter = (offset, limit, query) => async (dispatch) => {
	axios
		.get(`/leave-request/offset/${offset}/limit/${limit}?${query}`)
		.then((response) => {
			dispatch({ type: GET_LEAVES, payload: response.data });
		})
		.cathc((err) => {});
};
export const getLeave = (id) => async (dispatch) => {
	const response = await axios.get(`/leave-request/${id}`);
	dispatch({ type: GET_LEAVE, payload: response.data });
};
export const deleteLeave = (id, deleted, setDeleted) => async (dispatch) => {
	axios
		.delete(`/leave-request/${id}`)
		.then((response) => {
			dispatch({ type: DELETE_LEAVE, payload: response.data });
			setDeleted(!deleted);
		})
		.catch((err) => {});
};
export const updateLeave = (formValues) => async (dispatch) => {
	axios
		.put(`/leave-request/${formValues.id}`, formValues)
		.then((response) => {
			dispatch({ type: UPDATE_LEAVE, payload: response.data });
			history.push(Routes.HumanResources.Leave.Index.path);
		})
		.catch((err) => {
			console.log(err);
		});
};
